import * as Immutable from "immutable";
import generateId from "logic/generateId";
import { widgetDefinition } from "../Widgets";
import searchTypeDefinition from "../SearchType";
const filterForWidget = (widget) => widget.filter ? { filter: { type: "query_string", query: widget.filter } } : {};
export default (widgets) => {
  let widgetMapping = Immutable.Map();
  const searchTypes = Immutable.List(widgets).map(
    (widget) => widgetDefinition(widget.type).searchTypes(widget).map((searchType) => ({
      id: generateId(),
      timerange: widget.timerange,
      query: widget.query,
      streams: widget.streams,
      stream_categories: widget.streamCategories,
      ...searchType,
      widgetId: widget.id,
      ...filterForWidget(widget),
      filters: widget.filters
    }))
  ).reduce((acc, cur) => acc.merge(cur), Immutable.Set()).map((searchType) => {
    widgetMapping = widgetMapping.update(
      searchType.widgetId,
      Immutable.Set(),
      (widgetSearchTypes) => widgetSearchTypes.add(searchType.id)
    );
    const typeDefinition = searchTypeDefinition(searchType.type);
    if (!typeDefinition || !typeDefinition.defaults) {
      console.warn(`Unable to find type definition or defaults for search type ${searchType.type} - skipping!`);
    }
    const { defaults = {} } = typeDefinition || {};
    const {
      config,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      widgetId,
      ...rest
    } = searchType;
    return Immutable.Map(defaults).merge(rest).merge(config).merge({
      id: searchType.id,
      type: searchType.type
    }).toJS();
  }).toArray();
  return { widgetMapping, searchTypes };
};
